/**
 * Stable API client wrapper (non-generated).
 *
 * This file intentionally lives outside the generated `src/client` folder so that
 * running `npm run openapi-ts` does not overwrite custom logic (auth headers, base URL, etc.).
 *
 * Generated functions under `src/client` are pure and unaware of auth. We provide:
 *  - `authedClient`: a pre-configured client instance with the base URL
 *  - `withAuthHeaders(extra?)`: async helper to merge Firebase ID token into headers
 */
import { createClient, createConfig } from "@/client/client";
import { auth } from "@/lib/firebase/client";
import { getActiveOrgId } from "@/stores/org-store";

export const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:8000";

async function buildAuthHeaders() {
  const u = auth.currentUser;
  if (!u) return {} as Record<string, string>;
  const token = await u.getIdToken();
  const headers: Record<string, string> = { Authorization: `Bearer ${token}` };

  const orgId = getActiveOrgId();
  if (orgId) {
    headers["X-Org-Id"] = orgId;
  }

  return headers;
}

export const authedClient = createClient(
  createConfig({
    baseUrl: API_BASE,
  })
);

export async function withAuthHeaders(extra?: Record<string, string>) {
  return { ...(await buildAuthHeaders()), ...(extra || {}) } as Record<
    string,
    string
  >;
}
